'use client';

import { Service } from '@/types';


type Props = {
  services: Array<Service>
  callback: (navigator: { term: string, Url: string }) => void;
  listboxId?: string;
  activeIndex?: number;
}

export function Autocomplete({ services, callback, listboxId, activeIndex = -1 }: Props) {
  return (
    <>
      <ul id={listboxId} role='listbox' aria-label='Sugestões'>
        {
          services.map(({ Service, Url }, i) => {
            return (
              <li
                id={listboxId ? `${listboxId}-option-${i}` : undefined}
                role='option'
                aria-selected={i === activeIndex}
                onClick={() => callback({ term: Service, Url: Url })}
                className={`cursor-pointer w-full flex items-center px-[23px] min-h-[43px] border-b-[1px] border-bar hover:bg-bar ${i === activeIndex ? 'bg-bar' : ''}`}
                key={i}
              >
                {Service}
              </li>
            );

          })
        }
      </ul>

    </>
  );
}
